const formatDate = (date, overrideTime) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    if (overrideTime) {
        return (date.getMonth()+1) + "-" + date.getDate() + "-" + date.getFullYear();
    }
    return (date.getMonth()+1) + "-" + date.getDate() + "-" + date.getFullYear() + "  " + strTime;
}

const displayDateTime = (date, overrideTime=false, overrideTimezoneOffset=false) => {
    // return on null date 
    if (!date) {
        return 'None'; 
    }

    // initialize date obj for display date 
    let display = new Date(date); // this date is utc

    // console.log(date); 
    // console.log(display); 
    // console.log(display.getDate()); 
    // console.log(display.getHours()); 
    // console.log(display.getTimezoneOffset()); 

    // override timezone offset depending on flag
    if (overrideTimezoneOffset) {
        display.setHours(display.getHours() + (display.getTimezoneOffset() / 60)); 
    }

    // apply timezone offset
    // display.setHours(display.getHours() - (display.getTimezoneOffset() / 60)); 

    // return formatted string 
    return formatDate(display, overrideTime);  
}

export default displayDateTime; 